import { createContext, useContext } from "react";

export type MetricPanel = "trend" | "definition" | "quality" | "usage" | "edit" | "archive" | "delete" | "version" | "import" | "pin";
export const MetricActionsContext = createContext<{ open: (key: string, panel?: MetricPanel) => void; primary: () => void }>({ open: () => {}, primary: () => {} });
export const useMetricActions = () => useContext(MetricActionsContext);
